/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';

export interface IMiscCharges {
  id?: string;
  chargeName?: string | null;
  chargeCode?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  chargeAmount?: number | null;
  taxPercent?: number | null;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IMiscCharges> = {
  active: false,
  suspended: false,
  draft: false,
};
